"use strict";

var Sentry = require("./sentry");

function captureError(err, context = {}) {
  Sentry.withScope(scope => {
    scope.setExtra("context", context);
    Sentry.captureException(err);
  });
}

module.exports = captureError;



// WEBPACK FOOTER //
// ./app/util/browser/capture-error.js